import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  TravelerDetailsUIStoreModule,
} from '@refx/shared-store';
import {
  CheckoutPaymentInformationFactsService,
} from './checkout-payment-information.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule,
    TravelerDetailsUIStoreModule
  ],
  providers: [
    CheckoutPaymentInformationFactsService
  ]
})
export class CheckoutPaymentInformationFactsModule {}
